module.exports = __webpack_public_path__ + "img/valance-scallon.c1939ab7.jpg";